import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ot-dash-summary',
  templateUrl: './dash-summary.component.html',
  styleUrls: ['./dash-summary.component.scss'],
})
export class DashSummaryComponent implements OnInit {
  @Input() public data: any;
  @Input() public role: any;

  constructor() {}

  ngOnInit() {}
}
